import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";

@Component({
    selector: "app-status-filter",
    imports: [CommonModule, DxButtonModule],
    templateUrl: "./status-filter.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./status-filter.component.css"
})
export class StatusFilterComponent {
  @Input() id: number;
  @Input() label: string;
  @Input() indicatorColor: string;
  @Input() indicatorBorderColor: string;
  @Input() hashed: boolean;
  @Input() selected: boolean;
  @Input() count: number;
  @Output() filterChange = new EventEmitter<number>();

  // --primary-color (not --color-primary) is a stray, differently-defined legacy variable
  // (rgb(111,176,79)) — visibly not the same green as the brand's actual --color-primary token
  // (#629d37), which every other "active" state in this app (including the Deadlines chip this
  // component is the style reference for) uses.
  selectedStyle = {
    "background-color": "var(--color-primary)",
    color: "white",
  };

  unselectedStyle = {
    "background-color": "#DFDFDF",
    color: "black",
  };

  get indicatorStyle(): Record<string, string> {
    return {
      'background-color': this.indicatorColor ?? '',
      'border': this.indicatorBorderColor ? `2px solid ${this.indicatorBorderColor}` : 'none',
      'box-sizing': 'content-box',
    };
  }
}
